export default __webpack_public_path__ + "static/media/attacks.4ef4fd68.png";